import { atom, selector } from 'recoil'

export const oldSenderState = atom({
  key: 'EmailSendingQueueManage__oldSenderState',
  default: {
    email: undefined,
    name: undefined,
    count: 0
  }
})

export const newSenderState = atom({
  key: 'EmailSendingQueueManage__newSenderState',
  default: {
    email: undefined,
    name: undefined,
    count: 0
  }
})

export const isNameInputValidState = selector({
  key: 'EmailSendingQueueManage__isNameInputValidState',
  get: ({ get }) => {
    const { name } = get(newSenderState)
    return name.length > 0
  }
})

export const isScheduledSendingState = atom({
  key: 'EmailSendingQueueManage__IsScheduledSendingState',
  default: {
    isScheduledSending: false,
    scheduleModeSelected: undefined,
    scheduleMode: []
  }
})
